<template>
  <div class="control-detail">
    <div class="qc-detail" v-if="showItemDetail">
      <div v-for="(item) in checkResultList" :key="item.id">
        <div class="qc-detail-item">
          <span style="position: absolute;top: 10px; right: 20px; ">
            <span v-if="item.qualityResultDynamic == 4 || item.qualityResultDynamic == 5" @click="updateQualityResult(item)" style="color: #409EFF;cursor: pointer;">完成</span>
            <!-- <span v-if="item.qualityResultDynamic == 1" @click="showItemDetailHandler(item)" style="color: #409EFF;cursor: pointer;">编辑</span> -->
          </span>
          <div>
            质控人员：<span>{{ item.spotCheckUserName }} · {{item.spotCheckUserTypeName}}</span
            ><br />
            质控时间：<span>{{ item.spotCheckTime }}</span
            ><br />
            质控结果：<span>{{ item.qualityControlResult }}{{item.handleResultName?` | ${item.handleResultName}`:''}}</span><span class="is-good" v-if="item.isGood == '1'">优</span><br />
            详情描述：<span>{{ item.firstSpotCheckStateStr }}；</span>
            <div class="qc-detail-description"><span v-html="item.spotCheckRemarks"></span></div>
            <!-- 图片展示 -->
            <div v-if="picLoading" class="picture-show">
              <viewer :images="item.imageUrlAfter" class="image-view">
                <img
                  v-for="(item, index) in item.imageUrlAfter"
                  :key="index"
                  :src="item"
                  alt
                />
              </viewer>
            </div>
          </div>
          <div class="item-detail">
            <div class="item-detail-top">
              <span>{{item.qualityResultDynamicName}}</span>
              <span @click="getItemDetail(item)" style="cursor: pointer;">查看详情
                <i v-if="!showDetail" class="el-icon-arrow-down"></i>
                <i v-else class="el-icon-arrow-up"></i>
              </span>
            </div>
            <div class="item-detail-content" v-if="showDetail && timeStageActivities[0].spotCheckId == item.id">
              <el-timeline>
                <el-timeline-item v-for="(activity, index) in timeStageActivities" :key="index" :timestamp="activity.createTime" placement="top">
                  <div class="time-content-card">
                    <h4>{{activity.typeStr}}</h4>
                    <span v-if="activity.type==2">{{activity.failReason}}</span>
                    <p>{{activity.userName}} 提交于 {{activity.createTime}}</p>
                  </div>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="control-editor">
         <span @click="goBack" style="font-size:16px;cursor:pointer; "><i class="el-icon-arrow-left" style="color:#409EFF"></i>编辑质控结果</span>
       </div>
       <div class="editor-container">
         <EditResult type="edit" ref="EditResult" :detailData="currentQcDetailInfo" :currentPatientInfo="currentPatientInfo" @refresh="onload" @hadAddQc="hadAddQc"></EditResult>
       </div>
    </div>
    <!-- 我要质控  空状态 -->
    <div v-if="checkResultList.length == 0 && checkResultEmpty" class="qc-empty">
      <img src="../img/no-result.png" alt="loading" style="width:180px;margin-bottom: 20px;">
      <span style="margin-bottom: 20px;">暂无质控记录</span>
      <div><el-button type="primary" @click="wantAddQc" style="width: 200px;">我要质控</el-button></div>
    </div>
  </div>
  
</template>

<script>
import {
  RestFeedbackOutControllerGetFollowupSpotCheckRemarksList,// 获取抽查记录
  RestFeedbackOutControllerGetQualityTimeStage, //获取质控时间阶段（查看详情）
  RestNewFollowupCallCenterServiceUpdateQualityResultDynamicById

} from '@src/assets/js/api.js'
import EditResult from "./EditResult.vue";

export default {
  name: 'QualityControlDetail',
  props: {
    patientInfo: {
      type: Object,
      default: null
    },
    getCheckResult: {
      type: Function,
      default: null
    }},
  data() {
    return {
      taskId: localStorage.getItem('taskId'),
      currentPatientInfo:this.patientInfo,
      checkResultList: [],
      timeStageActivities: [],
      userId: localStorage.getItem('huidrUserId'),
      showDetail: false,
      showItemDetail: true,
      currentQcDetailInfo: null,   //点击编辑时的item
      hasSave: false,
      checkResultEmpty: false,
      picLoading:false
    }
  },
  components:{EditResult},
  mounted() {
    this.onload()
  },
  watch: {
    patientInfo: function(newval, oldval){
      this.currentPatientInfo = newval;
      this.onload()
    }
  },
  methods: {
    onload() {
      this.showItemDetail=true
      this.getCheckRemakeListHandler()
    },
    getCheckRemakeListHandler () {
      this.getCheckRemarksListAsync().then(res => {
          if (res.status == 0 && res.retValue.length >0) {
            this.checkResultList = res.retValue.map(item => {
              item.qualityControlResult = this.getqualityControlResult(item.secondSpotCheckState);
              item.handleResultName = this.getHandleresult(item.handleResult);
              item.spotCheckUserTypeName = this.getQualityControlPersonType(item.spotCheckUserType);
              item.qualityResultDynamicName = this.getType(item.qualityResultDynamic);
              // 标记
              let stateArr = item.firstSpotCheckState.substr(1,item.firstSpotCheckState.length-2).split(',');
              stateArr = stateArr.map(it => {
                return this.getSpotCheckState(it)
              })
              item.firstSpotCheckStateStr= stateArr.join(',')
              // 处理图片
              item.imageUrlAfter=[]
              if(item.imageUrl){
                this.getPicUrl(JSON.parse(JSON.stringify(item.imageUrl)))
                .then(pic => {
                  item.imageUrlAfter = pic
                  this.picLoading = true
                })
              }
              return item
            })
          }else {
            this.checkResultEmpty = true
            this.checkResultList=[]
            this.getCheckResult()
          }
        })
    },
    getItemDetail(itemData){
      this.showDetail = !this.showDetail
      let s=[]
      s.push(itemData.id);
      let p = {
        spotCheckId: s, 
        type: null 
      }
      this.getQualityTimeStageAsync(p).then(res => {
          if (res.status == 0) {
            this.timeStageActivities = res.retValue.map(item => {
              item.typeStr = this.getType(item.type);
              return item
            })
          }
        })
    },
    getPicUrl(picList) {
      return new Promise((resolve) => {
        this.$store.dispatch('getPicture', { url: picList }).then((res_) => {
         resolve(res_)
        })
      })
    },
    showItemDetailHandler(param){
      this.showItemDetail = false;
      this.currentQcDetailInfo = param;
    },
    updateQualityResult(param) {
      this.updateQualityResultDynamicAsync(param).then(res => {
          if (res.status == 0) {
            this.$message.success('更新成功');
            this.getCheckRemakeListHandler()
          }
        })
    },
    goBack(){
      let editData = JSON.stringify(this.$refs.EditResult.ruleForm)
      let temp = {
        editorInfo: this.currentQcDetailInfo.spotCheckRemarks,
        firstSpotCheckState: this.currentQcDetailInfo.firstSpotCheckState.substr(1,this.currentQcDetailInfo.firstSpotCheckState.length-2).split(','),
        isgood: this.currentQcDetailInfo.isGood,
        result: this.currentQcDetailInfo.qualityControlResult,
        handleResultName: this.currentQcDetailInfo.handleResultName
      }
      let afterData = JSON.stringify(temp)
      if(this.hasSave || editData == afterData){
        this.showItemDetail = true
      }else {
        // 编辑
        this.$confirm('您编辑的质控记录还没有保存是否直接退出?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          this.showItemDetail = true;
        })
        .catch(() => {
          // 取消编辑
        })
      }
    },
    // 我要质控
    wantAddQc(){
      this.$emit('wantAddQc')
    },
    hadAddQc(){
      this.hasSave =true;
      this.onload()
    },
    getqualityControlResult(type) {
      if(type == '1' || type == '5' ||type == '15' ||type == '16' ||type == '17' ||type == '18' || type == '19' || type == '20') {
        return '合格'
      }else {
        return '不合格'
      }
    },
    getHandleresult(state) {
      switch (state) {
        case 1:
          return '需重拨'
          break
        case 2:
          return '需注意'
          break
        case 3:
          return '平台相关'
          break
        case 4:
          return '需修改问卷'
          break
      }
    },
    getQualityControlPersonType(state){
      switch (state) {
        case 0:
          return '内部'
          break
        case 1:
          return '外部'
          break
        case 2:
        return '呼叫中心'
        break
      }
    },
    getType(type) {
      switch (type) {
        case 1:
          return '质控结果已提交（待审核）'
          break
        case 2:
          return '审核不通过'
          break
        case 3:
          return '审核通过（已发送坐席）'
          break
        case 4:
          return '坐席已读（待跟踪）'
          break
        case 5:
          return '坐席已编辑（待跟踪）'
          break
        case 6:
          return '质控完成'
          break
      }
    },
    getSpotCheckState(state) {
      switch (state) {
        case '8':return '收集不足';break
        case '9':return '态度欠佳';break
        case '10':return '录音缺失';break
        case '11':return '记录有误';break
        case '15':return '逻辑清晰';break
        case '16':return '收集完整';break
        case '17':return '态度良好';break
        case '18':return '记录准确';break

        case '21':return '混乱无序';break
        case '22':return '清楚流利';break
        case '23':return '生疏含混';break
        case '24':return '积极灵活';break
        case '25':return '刻板迟钝';break
      }
    },
    // ========================获取数据===========================
    // 获取抽查记录
    async getCheckRemarksListAsync () {
      let request = new RestFeedbackOutControllerGetFollowupSpotCheckRemarksList()
      request.p_followUpTaskId = this.taskId
      request.p_followUpTaskPatientInfoId = this.currentPatientInfo.followupPatientInfoId
      await request.send()
      return request.result
    },
    async getQualityTimeStageAsync (p) {
      let request = new RestFeedbackOutControllerGetQualityTimeStage()
      request.p_spotCheckId=p.spotCheckId
      request.p_type=p.type
      await request.send()
      return request.result
    },
    async updateQualityResultDynamicAsync (p) {
      let _id = []
      let _fpid =[]
      _id.push(p.id)
      _fpid.push(this.currentPatientInfo.followupPatientInfoId)
      let request = new RestNewFollowupCallCenterServiceUpdateQualityResultDynamicById()
      request.p_spotCheckId= _id,
      request.p_userId=this.userId *1;
      request.p_userType= 0;
      request.p_qualityResultDynamic=6,
      request.p_followUpPatientInfoId=  _fpid,
      request.p_isCompleteTrack= 1,
      await request.send()
      return request.result
    },
  },
}
</script>

<style lang="scss" scoped>
.control-detail {
      height: calc(100vh - 440px);
      overflow: auto;
}
.qc-detail {
  .qc-detail-item {
      // margin: 8px 0;
      padding: 10px;
      line-height: 26px;
      border-radius: 8px;
      position: relative;
      span {
        color: #000;
      }
      .is-good {
        margin: 0 5px;
        color: red;
        background: yellow;
      }
    }
    .qc-detail-item:hover {
      background: #f4f4f4;
    }
    
    .item-detail {
      border-top: 1px solid #ccc;
      padding: 8px;
      padding-bottom: 0;
      &-top {
        display: flex;
        justify-content: space-between;
      }
      &-content {
        .time-content-card {
          border: 1px solid #eee;
          border-radius: 6px;
          padding: 5px;
        }
      }
    }
    .picture-show {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .image-view {
        width: 100%;
      }
      .image-view > img {
        width: 40px;
        height: 40px;
        margin-right: 8px;
        text-align: center;
        cursor: pointer;
      }
    }
}
.control-editor {
  margin: 8px 0;
}
.qc-empty {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
<style lang="scss">
// 有序无序被覆盖
  .control-detail{
    .qc-detail-description {
      p {
        word-break: break-all ;
        word-wrap: break-word ;
      }
      ul {
        padding: 0 1em;
        list-style-type: disc !important;
        list-style-position: inside !important;
      }
      ol {
        padding: 0 1em;
        list-style-type: decimal !important;
        list-style-position: inside !important;
      }
      li {
        white-space:normal;
        word-break : break-all;
        word-wrap: break-word;
      }
    }
    .ql-size-large {
      font-size: 1.5em;
    }
    .ql-size-small {
      font-size: 0.75em;
    }
    .ql-size-huge {
      font-size: 2.5em;
    }
  }
</style>
